<div class="d-inline profile p-3">
    <div>
        <div class="background">

            <div class="circle"></div>
            <div class="close d-flex justify-content-center align-items-center" (click)="closeDialog()">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24 ">
                    <path fill="currentColor"
                        d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
                </svg>
            </div>
        </div>
    </div>
    <div class=" content ">
        <div class="d-flex m-1 fs-20 p-1">
            <div class="d-flex p-1">
                <div class="d-flex"> Ethan Johnson</div>
                <!--<div class="d-flex p-1" (click)="onEdit()"> <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m16.475 5.408l2.117 2.117m-.756-3.982L12.109 9.27a2.1 2.1 0 0 0-.58 1.082L11 13l2.648-.53c.41-.082.786-.283 1.082-.579l5.727-5.727a1.853 1.853 0 1 0-2.621-2.621"/><path d="M19 15v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3"/></g></svg></div>-->
            </div>
        </div>
        <div class="d-flex m-1 p-1 fs-16">
            <div class="d-flex p-1"> Senior Member | Resolved More Than 1000k Profiles </div>
        </div>
        <div class="d-flex m-1 location">
            <div class="d-flex p-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <g fill="none" stroke="#0d6efd" stroke-linejoin="round" stroke-width="1.5">
                        <path
                            d="M6.4 4.76a7.92 7.92 0 0 1 11.2 11.2l-4.186 4.186a2 2 0 0 1-2.828 0L6.4 15.96a7.92 7.92 0 0 1 0-11.2Z" />
                        <circle cx="12" cy="10.36" r="3" stroke-linecap="round" />
                    </g>
                </svg>&nbsp;
                123 High Street, Local Area ,SW1A 1AA, UNITED KINGDOM
            </div>
        </div>
        <div class="d-flex m-1 justify-content-start  p-1">
            <div class="d-flex p-1">As a senior member in medical evidence team , He Resolved More Than 1000k profiles.
                He Can Screen more Than 50 profiles a day by gathering information from different resources of united
                kingdom ,He is an United Kingdom (UK) Certified Medical Evidence from 2019</div>
        </div>
        <div class="d-flex m-1  p-1  ">
            <div class="d-flex p-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill=""
                        d="M4.616 19q-.691 0-1.153-.462T3 17.384V6.616q0-.691.463-1.153T4.615 5h14.77q.69 0 1.152.463T21 6.616v10.769q0 .69-.463 1.153T19.385 19zM20 6.885l-7.552 4.944q-.106.055-.214.093q-.109.037-.234.037t-.234-.037t-.214-.093L4 6.884v10.5q0 .27.173.443t.443.173h14.769q.269 0 .442-.173t.173-.443zM12 11l7.692-5H4.308zM4 6.885v.211v-.811v.034V6v.32v-.052v.828zV18z" />
                </svg>
            </div>
            <div class="d-flex p-1"> johson.uk.com </div>
            <div class="d-flex p-1"> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill=""
                        d="M18.438 4.954H16.5V3.546c0-.262-.23-.512-.5-.5a.51.51 0 0 0-.5.5v1.408h-7V3.546c0-.262-.23-.512-.5-.5a.51.51 0 0 0-.5.5v1.408H5.562a2.503 2.503 0 0 0-2.5 2.5v11c0 1.379 1.122 2.5 2.5 2.5h12.875c1.379 0 2.5-1.121 2.5-2.5v-11a2.5 2.5 0 0 0-2.499-2.5m-12.876 1H7.5v.592c0 .262.23.512.5.5c.271-.012.5-.22.5-.5v-.592h7v.592c0 .262.23.512.5.5c.271-.012.5-.22.5-.5v-.592h1.937c.827 0 1.5.673 1.5 1.5v1.584H4.062V7.454c0-.827.673-1.5 1.5-1.5m12.876 14H5.562c-.827 0-1.5-.673-1.5-1.5v-8.416h15.875v8.416a1.5 1.5 0 0 1-1.499 1.5" />
                </svg> </div>
            <div class="d-flex p-1">12 Dec 1997 </div>
            <div class="d-flex p-1"> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="" fill-rule="evenodd"
                        d="M5.733 2.043c1.217-1.21 3.221-.995 4.24.367l1.262 1.684c.83 1.108.756 2.656-.229 3.635l-.238.238a.65.65 0 0 0-.008.306c.063.408.404 1.272 1.832 2.692s2.298 1.76 2.712 1.824a.7.7 0 0 0 .315-.009l.408-.406c.876-.87 2.22-1.033 3.304-.444l1.91 1.04c1.637.888 2.05 3.112.71 4.445l-1.421 1.412c-.448.445-1.05.816-1.784.885c-1.81.169-6.027-.047-10.46-4.454c-4.137-4.114-4.931-7.702-5.032-9.47l.749-.042l-.749.042c-.05-.894.372-1.65.91-2.184zm3.04 1.266c-.507-.677-1.451-.731-1.983-.202l-1.57 1.56c-.33.328-.488.69-.468 1.036c.08 1.405.72 4.642 4.592 8.492c4.062 4.038 7.813 4.159 9.263 4.023c.296-.027.59-.181.865-.454l1.42-1.413c.578-.574.451-1.62-.367-2.064l-1.91-1.039c-.528-.286-1.146-.192-1.53.19l-.455.453l-.53-.532c.53.532.529.533.528.533l-.001.002l-.003.003l-.007.006l-.015.014a1 1 0 0 1-.136.106c-.08.053-.186.112-.319.161c-.27.101-.628.155-1.07.087c-.867-.133-2.016-.724-3.543-2.242c-1.526-1.518-2.122-2.66-2.256-3.526c-.069-.442-.014-.8.088-1.07a1.5 1.5 0 0 1 .238-.42l.032-.035l.014-.015l.006-.006l.003-.003l.002-.002l.53.53l-.53-.531l.288-.285c.428-.427.488-1.134.085-1.673z"
                        clip-rule="evenodd" />
                </svg> </div>
            <div class="d-flex p-1"> +44 20 7123 4567 </div>
        </div>
        <!-- <div class="d-flex m-1 p-1">  <div class="d-flex p-1" > <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1" opacity="0.5"/><path fill="currentColor" d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3"/></svg> </div> <div class="d-flex p-1">12 Dec 1997 </div></div>
<div class="d-flex m-1 p-1" ><div class="d-flex p-1" > <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-dasharray="64" stroke-dashoffset="64" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 3c0.5 0 2.5 4.5 2.5 5c0 1 -1.5 2 -2 3c-0.5 1 0.5 2 1.5 3c0.39 0.39 2 2 3 1.5c1 -0.5 2 -2 3 -2c0.5 0 5 2 5 2.5c0 2 -1.5 3.5 -3 4c-1.5 0.5 -2.5 0.5 -4.5 0c-2 -0.5 -3.5 -1 -6 -3.5c-2.5 -2.5 -3 -4 -3.5 -6c-0.5 -2 -0.5 -3 0 -4.5c0.5 -1.5 2 -3 4 -3Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0"/></path></svg> </div><div class="d-flex p-1"> +44 20 7123 4567 </div> </div> -->
    </div>


    @if(editable){

    <div class="d-inline">

        <div class="d-flex justify-content-center">

            <div class="edit    m-3 p-3">
                <div class="d-flex justify-content-between">
                    <div>
                        <p class="d-flex justify-content-center heading">Edit Profile</p>
                    </div>
                    <div>
                        <div (click)="onclose()" class="cross-icon d-flex justify-content-center align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 21">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    d="m15.5 15.5l-10-10zm0-10l-10 10" stroke-width="1" />
                            </svg>
                        </div>
                    </div>
                </div>

                <form [formGroup]="editform" (ngSubmit)="onEditForm()" class="d-flex flex-column m-3">

                    <table class="d-flex flex-column ">

                        <td class="d-flex justify-content-around ">

                            <mat-form-field class="example-full-width d-flex p-3 " appearance="outline">
                                <mat-label color="primary"> Email</mat-label>
                                <input matInput type="text" formControlName="email" required>
                                <svg matTextSuffix="" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
                                    viewBox="0 0 28 28">
                                    <path fill="currentColor"
                                        d="M5.754 4a3.75 3.75 0 0 0-3.75 3.75v11.5A3.75 3.75 0 0 0 5.754 23H22.25A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25H22.25a2.25 2.25 0 0 1 2.25 2.25v.779L14 13.907L3.504 8.531zm0 2.467l10.154 5.2a.75.75 0 0 0 .684 0L24.5 10.215v9.036a2.25 2.25 0 0 1-2.25 2.25H5.755a2.25 2.25 0 0 1-2.25-2.25z" />
                                </svg>
                                @if(editform.get('email')?.hasError('required')){
                                <mat-error> Please Enter Editable Email</mat-error>}
                            </mat-form-field>
                            <mat-form-field class="example-full-width d-flex p-3" appearance="outline">
                                <mat-label color="primary"> Phone Number</mat-label>
                                <input matInput type="text" formControlName="phonenumber" required>
                                <svg matTextSuffix="" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24">
                                    <path fill="none" stroke="currentColor" stroke-dasharray="64" stroke-dashoffset="64"
                                        stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M8 3c0.5 0 2.5 4.5 2.5 5c0 1 -1.5 2 -2 3c-0.5 1 0.5 2 1.5 3c0.39 0.39 2 2 3 1.5c1 -0.5 2 -2 3 -2c0.5 0 5 2 5 2.5c0 2 -1.5 3.5 -3 4c-1.5 0.5 -2.5 0.5 -4.5 0c-2 -0.5 -3.5 -1 -6 -3.5c-2.5 -2.5 -3 -4 -3.5 -6c-0.5 -2 -0.5 -3 0 -4.5c0.5 -1.5 2 -3 4 -3Z">
                                        <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s"
                                            values="64;0" />
                                    </path>
                                </svg>
                                @if(editform.get('phonenumber')?.hasError('required')){ <mat-error>Please Enter Editable
                                    Phone Number</mat-error>}
                            </mat-form-field>
                        </td>
                        <td class="d-flex justify-content-around">
                            <mat-form-field class="example-full-width d-flex p-3" appearance="outline">
                                <mat-label color="primary"> Address</mat-label>
                                <input matInput type="text" formControlName="adress" required>
                                <svg matTextSuffix="" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24">
                                    <path fill="#000" fill-rule="evenodd"
                                        d="m12.065 21.243l-.006-.005zm.182-.274a29 29 0 0 0 3.183-3.392c2.04-2.563 3.281-5.09 3.365-7.337a6.8 6.8 0 1 0-13.591 0c.085 2.247 1.327 4.774 3.366 7.337a29 29 0 0 0 3.183 3.392q.166.15.247.218zm-.985 1.165S4 16.018 4 10a8 8 0 1 1 16 0c0 6.018-7.262 12.134-7.262 12.134c-.404.372-1.069.368-1.476 0M12 12.8a2.8 2.8 0 1 0 0-5.6a2.8 2.8 0 0 0 0 5.6m0 1.2a4 4 0 1 1 0-8a4 4 0 0 1 0 8" />
                                </svg>
                                @if(editform.get('adress')?.hasError('required')){<mat-error>Please Enter Editable
                                    Adress</mat-error>}
                            </mat-form-field>
                            <mat-form-field class="example-full-width d-flex p-3" appearance="outline">
                                <mat-label color="primary"> Designation</mat-label>
                                <input matInput type="text" formControlName="designation" required>
                                <svg matTextSuffix="" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24">
                                    <g fill="none" stroke="currentColor" stroke-width="1">
                                        <path stroke-linejoin="round"
                                            d="M4 18a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
                                        <circle cx="12" cy="7" r="3" />
                                    </g>
                                </svg>
                                @if(editform.get('designation')?.hasError('required')){ <mat-error>Please Enter Editable
                                    Designation</mat-error>}
                            </mat-form-field>
                        </td>


                        <button class="primaryBtn mt-3 mb-3 loginBtn" [disabled]="!editform.valid">
                            Edit
                        </button>

                    </table>




                </form>
            </div>
        </div>
    </div>




    }


</div>